var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoloNftBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486 486",
    style: {
      enableBackground: "new 0 0 486 486"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#186CF1;}\n\t.st1{fill:#0A56D4;}\n\t.st2{fill:#0553DB;}\n\t.st3{fill:#0547B7;}\n\t.st4{fill:#115FDD;}\n\t.st5{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 153,
    className: "st0",
    width: 36,
    height: 45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 153,
    className: "st0",
    width: 9,
    height: 18
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 198,
    className: "st0",
    width: 27,
    height: 18
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 216,
    className: "st0",
    width: 18,
    height: 81
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 270,
    className: "st0",
    width: 9,
    height: 72
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 297,
    className: "st0",
    width: 9,
    height: 27
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 315,
    className: "st0",
    width: 9,
    height: 45
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 333,
    className: "st0",
    width: 9,
    height: 36
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 351,
    className: "st0",
    width: 9,
    height: 27
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 369,
    className: "st0",
    width: 9,
    height: 18
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 378,
    className: "st0",
    width: 9,
    height: 18
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 387,
    className: "st0",
    width: 9,
    height: 18
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 396,
    className: "st0",
    width: 9,
    height: 18
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 405,
    className: "st0",
    width: 9,
    height: 9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 135,
    className: "st0",
    width: 45,
    height: 18
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 117,
    className: "st0",
    width: 45,
    height: 18
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 108,
    className: "st0",
    width: 45,
    height: 9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 99,
    className: "st0",
    width: 45,
    height: 9
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 90,
    className: "st0",
    width: 45,
    height: 9
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 81,
    className: "st0",
    width: 45,
    height: 9
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 72,
    className: "st0",
    width: 45,
    height: 9
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 63,
    className: "st0",
    width: 54,
    height: 9
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 54,
    className: "st0",
    width: 72,
    height: 9
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 45,
    className: "st0",
    width: 81,
    height: 9
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 36,
    className: "st0",
    width: 171,
    height: 9
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 27,
    className: "st0",
    width: 36,
    height: 9
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 45,
    className: "st0",
    width: 99,
    height: 9
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 63,
    className: "st0",
    width: 162,
    height: 63
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 54,
    className: "st0",
    width: 144,
    height: 9
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 63,
    className: "st0",
    width: 9,
    height: 45
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 72,
    className: "st0",
    width: 9,
    height: 27
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 81,
    className: "st0",
    width: 9,
    height: 9
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 72,
    className: "st0",
    width: 18,
    height: 54
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 126,
    className: "st0",
    width: 9,
    height: 9
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 81,
    className: "st0",
    width: 9,
    height: 36
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 90,
    className: "st0",
    width: 9,
    height: 27
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 99,
    className: "st0",
    width: 9,
    height: 27
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 108,
    className: "st0",
    width: 9,
    height: 36
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 126,
    className: "st0",
    width: 9,
    height: 36
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 135,
    className: "st0",
    width: 9,
    height: 63
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 153,
    className: "st0",
    width: 9,
    height: 27
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 180,
    className: "st0",
    width: 18,
    height: 126
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 234,
    className: "st0",
    width: 9,
    height: 18
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 126,
    className: "st0",
    width: 63,
    height: 54
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 126,
    className: "st0",
    width: 9,
    height: 45
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 126,
    className: "st0",
    width: 9,
    height: 27
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 126,
    className: "st0",
    width: 9,
    height: 18
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 126,
    className: "st0",
    width: 18,
    height: 9
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 117,
    className: "st0",
    width: 18,
    height: 18
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 108,
    className: "st0",
    width: 9,
    height: 9
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 144,
    className: "st0",
    width: 9,
    height: 18
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 153,
    className: "st0",
    width: 9,
    height: 9
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 153,
    className: "st0",
    width: 9,
    height: 9
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 144,
    className: "st0",
    width: 9,
    height: 18
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 162,
    className: "st0",
    width: 90,
    height: 144
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 189,
    className: "st0",
    width: 9,
    height: 108
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 180,
    className: "st0",
    width: 9,
    height: 27
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 180,
    className: "st0",
    width: 27,
    height: 27
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 234,
    className: "st0",
    width: 9,
    height: 18
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 207,
    className: "st0",
    width: 54,
    height: 54
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 207,
    className: "st0",
    width: 9,
    height: 117
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 261,
    className: "st0",
    width: 9,
    height: 54
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 261,
    className: "st0",
    width: 9,
    height: 45
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 261,
    className: "st0",
    width: 9,
    height: 27
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 261,
    className: "st0",
    width: 9,
    height: 18
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 261,
    className: "st0",
    width: 9,
    height: 9
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 306,
    className: "st0",
    width: 18,
    height: 27
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 306,
    className: "st0",
    width: 45,
    height: 9
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 315,
    className: "st0",
    width: 45,
    height: 9
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 324,
    className: "st0",
    width: 36,
    height: 18
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 333,
    className: "st0",
    width: 36,
    height: 9
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 342,
    className: "st0",
    width: 54,
    height: 9
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 351,
    className: "st0",
    width: 18,
    height: 9
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 360,
    className: "st0",
    width: 9,
    height: 9
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 351,
    className: "st0",
    width: 9,
    height: 18
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 351,
    className: "st0",
    width: 18,
    height: 27
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 414,
    className: "st0",
    width: 18,
    height: 9
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 423,
    className: "st0",
    width: 18,
    height: 9
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 432,
    className: "st0",
    width: 18,
    height: 9
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 288,
    className: "st0",
    width: 9,
    height: 54
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 306,
    className: "st0",
    width: 9,
    height: 18
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 324,
    className: "st0",
    width: 9,
    height: 36
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 342,
    className: "st0",
    width: 9,
    height: 27
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 360,
    className: "st0",
    width: 9,
    height: 18
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 369,
    className: "st0",
    width: 9,
    height: 18
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 378,
    className: "st0",
    width: 9,
    height: 18
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 387,
    className: "st0",
    width: 9,
    height: 18
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 396,
    className: "st0",
    width: 9,
    height: 18
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 405,
    className: "st0",
    width: 9,
    height: 9
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 414,
    className: "st0",
    width: 9,
    height: 9
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 423,
    className: "st0",
    width: 9,
    height: 9
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 432,
    className: "st0",
    width: 18,
    height: 9
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 441,
    className: "st0",
    width: 54,
    height: 9
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 333,
    className: "st0",
    width: 18,
    height: 27
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 351,
    className: "st0",
    width: 9,
    height: 9
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 171,
    className: "st0",
    width: 63,
    height: 54
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 162,
    className: "st0",
    width: 45,
    height: 9
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 153,
    className: "st0",
    width: 18,
    height: 9
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 225,
    className: "st0",
    width: 36,
    height: 9
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 234,
    className: "st0",
    width: 27,
    height: 9
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 225,
    className: "st0",
    width: 9,
    height: 18
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 45,
    className: "st1",
    width: 36,
    height: 9
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 54,
    className: "st1",
    width: 27,
    height: 9
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 63,
    className: "st1",
    width: 27,
    height: 9
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 72,
    className: "st1",
    width: 36,
    height: 9
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 81,
    className: "st1",
    width: 36,
    height: 9
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 90,
    className: "st1",
    width: 36,
    height: 9
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 99,
    className: "st1",
    width: 27,
    height: 18
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 108,
    className: "st1",
    width: 9,
    height: 9
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 117,
    className: "st1",
    width: 27,
    height: 9
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 126,
    className: "st1",
    width: 27,
    height: 18
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 135,
    className: "st1",
    width: 9,
    height: 9
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 144,
    className: "st1",
    width: 27,
    height: 18
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 153,
    className: "st1",
    width: 9,
    height: 9
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 162,
    className: "st1",
    width: 27,
    height: 27
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 171,
    className: "st1",
    width: 9,
    height: 18
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 189,
    className: "st1",
    width: 27,
    height: 117
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 216,
    className: "st1",
    width: 9,
    height: 54
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 297,
    className: "st1",
    width: 9,
    height: 63
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 306,
    className: "st1",
    width: 18,
    height: 27
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 333,
    className: "st1",
    width: 9,
    height: 18
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 324,
    className: "st1",
    width: 9,
    height: 54
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 342,
    className: "st1",
    width: 9,
    height: 45
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 360,
    className: "st1",
    width: 9,
    height: 36
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 369,
    className: "st1",
    width: 9,
    height: 36
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 378,
    className: "st1",
    width: 117,
    height: 36
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 369,
    className: "st1",
    width: 90,
    height: 9
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 360,
    className: "st1",
    width: 72,
    height: 9
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 351,
    className: "st1",
    width: 63,
    height: 9
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 342,
    className: "st1",
    width: 54,
    height: 9
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 333,
    className: "st1",
    width: 45,
    height: 9
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 324,
    className: "st1",
    width: 45,
    height: 9
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 315,
    className: "st1",
    width: 36,
    height: 9
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 306,
    className: "st1",
    width: 36,
    height: 9
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 288,
    className: "st1",
    width: 198,
    height: 18
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 306,
    className: "st1",
    width: 126,
    height: 10
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 316,
    className: "st1",
    width: 117,
    height: 8
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 324,
    className: "st1",
    width: 45,
    height: 9
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 324,
    className: "st1",
    width: 36,
    height: 9
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 333,
    className: "st1",
    width: 36,
    height: 27
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 333,
    className: "st1",
    width: 27,
    height: 9
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 342,
    className: "st1",
    width: 18,
    height: 9
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 351,
    className: "st1",
    width: 18,
    height: 9
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 360,
    className: "st1",
    width: 72,
    height: 18
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 369,
    className: "st1",
    width: 9,
    height: 9
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 378,
    className: "st1",
    width: 81,
    height: 9
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 387,
    className: "st1",
    width: 99,
    height: 9
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 396,
    className: "st1",
    width: 90,
    height: 9
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 405,
    className: "st1",
    width: 81,
    height: 9
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 414,
    className: "st1",
    width: 180,
    height: 9
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 423,
    className: "st1",
    width: 144,
    height: 9
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 432,
    className: "st1",
    width: 99,
    height: 9
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 279,
    className: "st1",
    width: 198,
    height: 9
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 270,
    className: "st1",
    width: 63,
    height: 9
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 261,
    className: "st1",
    width: 36,
    height: 9
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 252,
    className: "st1",
    width: 18,
    height: 9
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 270,
    className: "st1",
    width: 81,
    height: 9
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 261,
    className: "st1",
    width: 63,
    height: 9
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 252,
    className: "st1",
    width: 54,
    height: 9
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 234,
    className: "st1",
    width: 45,
    height: 18
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 207,
    className: "st1",
    width: 36,
    height: 27
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 198,
    className: "st1",
    width: 27,
    height: 9
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 162,
    className: "st1",
    width: 27,
    height: 36
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 144,
    className: "st1",
    width: 27,
    height: 18
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 144,
    className: "st1",
    width: 9,
    height: 9
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 126,
    className: "st1",
    width: 36,
    height: 18
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 117,
    className: "st1",
    width: 18,
    height: 9
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 351,
    className: "st1",
    width: 18,
    height: 9
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 99,
    className: "st1",
    width: 9,
    height: 9
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    y: 180,
    className: "st2",
    width: 9,
    height: 126
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 198,
    className: "st2",
    width: 9,
    height: 135
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 297,
    className: "st2",
    width: 9,
    height: 54
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 324,
    className: "st2",
    width: 9,
    height: 45
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 342,
    className: "st2",
    width: 9,
    height: 45
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 360,
    className: "st2",
    width: 9,
    height: 36
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 369,
    className: "st2",
    width: 9,
    height: 36
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 378,
    className: "st2",
    width: 9,
    height: 36
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 387,
    className: "st2",
    width: 9,
    height: 36
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 396,
    className: "st2",
    width: 9,
    height: 36
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 405,
    className: "st2",
    width: 9,
    height: 36
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 414,
    className: "st2",
    width: 18,
    height: 36
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 423,
    className: "st2",
    width: 18,
    height: 36
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 432,
    className: "st2",
    width: 18,
    height: 36
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 441,
    className: "st2",
    width: 45,
    height: 36
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 477,
    className: "st2",
    width: 126,
    height: 9
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 450,
    className: "st2",
    width: 135,
    height: 27
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 441,
    className: "st2",
    width: 90,
    height: 9
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 432,
    className: "st2",
    width: 72,
    height: 9
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 423,
    className: "st2",
    width: 54,
    height: 9
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 414,
    className: "st2",
    width: 54,
    height: 9
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 405,
    className: "st2",
    width: 45,
    height: 9
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 396,
    className: "st2",
    width: 45,
    height: 9
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 387,
    className: "st2",
    width: 45,
    height: 9
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 378,
    className: "st2",
    width: 36,
    height: 9
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 369,
    className: "st2",
    width: 72,
    height: 9
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 360,
    className: "st2",
    width: 72,
    height: 9
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 342,
    className: "st2",
    width: 63,
    height: 18
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 459,
    y: 342,
    className: "st2",
    width: 9,
    height: 9
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 324,
    className: "st2",
    width: 27,
    height: 18
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 306,
    className: "st2",
    width: 27,
    height: 18
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 252,
    className: "st2",
    width: 63,
    height: 54
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 234,
    className: "st2",
    width: 54,
    height: 18
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 207,
    className: "st2",
    width: 63,
    height: 27
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 189,
    className: "st2",
    width: 27,
    height: 18
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 180,
    className: "st2",
    width: 18,
    height: 9
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 153,
    className: "st2",
    width: 63,
    height: 27
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 135,
    className: "st2",
    width: 63,
    height: 18
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 126,
    className: "st2",
    width: 36,
    height: 9
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 117,
    className: "st2",
    width: 36,
    height: 9
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 108,
    className: "st2",
    width: 27,
    height: 9
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 90,
    className: "st2",
    width: 27,
    height: 18
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 90,
    className: "st2",
    width: 9,
    height: 9
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 81,
    className: "st2",
    width: 36,
    height: 9
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 72,
    className: "st2",
    width: 72,
    height: 9
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 63,
    className: "st2",
    width: 81,
    height: 9
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 54,
    className: "st2",
    width: 81,
    height: 9
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 45,
    className: "st2",
    width: 90,
    height: 9
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 36,
    className: "st2",
    width: 108,
    height: 9
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 27,
    className: "st2",
    width: 144,
    height: 9
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 27,
    className: "st2",
    width: 72,
    height: 9
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 18,
    className: "st2",
    width: 216,
    height: 9
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 9,
    className: "st2",
    width: 180,
    height: 9
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    className: "st2",
    width: 126,
    height: 9
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 99,
    className: "st2",
    width: 9,
    height: 9
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 90,
    className: "st2",
    width: 9,
    height: 9
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 81,
    className: "st2",
    width: 9,
    height: 9
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 72,
    className: "st2",
    width: 9,
    height: 9
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 63,
    className: "st2",
    width: 9,
    height: 9
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 36,
    className: "st2",
    width: 9,
    height: 9
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 459,
    className: "st2",
    width: 18,
    height: 9
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 450,
    className: "st2",
    width: 36,
    height: 9
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 333,
    className: "st2",
    width: 9,
    height: 27
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 153,
    className: "st2",
    width: 9,
    height: 9
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 162,
    className: "st2",
    width: 18,
    height: 9
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 180,
    className: "st2",
    width: 18,
    height: 45
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 171,
    className: "st2",
    width: 9,
    height: 9
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 225,
    className: "st2",
    width: 18,
    height: 9
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 234,
    className: "st2",
    width: 18,
    height: 9
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 108,
    className: "st2",
    width: 9,
    height: 9
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 117,
    className: "st2",
    width: 9,
    height: 18
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 135,
    className: "st2",
    width: 9,
    height: 9
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 81,
    className: "st3",
    width: 36,
    height: 9
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 90,
    className: "st3",
    width: 36,
    height: 18
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 117,
    className: "st3",
    width: 27,
    height: 18
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 99,
    className: "st3",
    width: 9,
    height: 18
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 108,
    className: "st3",
    width: 27,
    height: 9
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 117,
    className: "st3",
    width: 9,
    height: 9
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 180,
    className: "st3",
    width: 45,
    height: 9
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 189,
    className: "st3",
    width: 36,
    height: 18
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 306,
    className: "st3",
    width: 36,
    height: 27
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 324,
    className: "st3",
    width: 9,
    height: 18
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 333,
    className: "st3",
    width: 27,
    height: 9
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 378,
    className: "st3",
    width: 45,
    height: 9
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 387,
    className: "st3",
    width: 36,
    height: 9
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 396,
    className: "st3",
    width: 36,
    height: 9
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 405,
    className: "st3",
    width: 36,
    height: 9
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 414,
    className: "st3",
    width: 36,
    height: 9
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 423,
    className: "st3",
    width: 36,
    height: 9
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 432,
    className: "st3",
    width: 36,
    height: 9
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 441,
    className: "st3",
    width: 45,
    height: 9
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 405,
    className: "st3",
    width: 9,
    height: 9
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 396,
    className: "st3",
    width: 9,
    height: 9
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 387,
    className: "st3",
    width: 9,
    height: 9
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 378,
    className: "st3",
    width: 9,
    height: 9
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 333,
    className: "st3",
    width: 9,
    height: 9
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 342,
    className: "st3",
    width: 9,
    height: 18
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 351,
    className: "st3",
    width: 9,
    height: 18
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 360,
    className: "st3",
    width: 9,
    height: 18
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 198,
    className: "st4",
    width: 9,
    height: 9
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 117,
    className: "st4",
    width: 9,
    height: 9
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 306,
    className: "st4",
    width: 9,
    height: 9
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 360,
    className: "st4",
    width: 9,
    height: 9
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 423,
    className: "st4",
    width: 9,
    height: 9
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 90,
    className: "st5",
    width: 9,
    height: 18
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 108,
    className: "st5",
    width: 27,
    height: 36
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 99,
    className: "st5",
    width: 9,
    height: 9
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 144,
    className: "st5",
    width: 63,
    height: 9
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 135,
    className: "st5",
    width: 9,
    height: 9
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 108,
    className: "st5",
    width: 9,
    height: 9
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 90,
    className: "st5",
    width: 9,
    height: 9
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 99,
    className: "st5",
    width: 18,
    height: 9
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 126,
    className: "st5",
    width: 18,
    height: 18
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 135,
    className: "st5",
    width: 9,
    height: 9
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 117,
    className: "st5",
    width: 9,
    height: 9
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 153,
    className: "st5",
    width: 45,
    height: 9
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 180,
    className: "st5",
    width: 27,
    height: 27
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 324,
    className: "st5",
    width: 27,
    height: 27
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 126,
    className: "st5",
    width: 54,
    height: 9
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 135,
    className: "st5",
    width: 81,
    height: 18
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 144,
    className: "st5",
    width: 9,
    height: 9
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 153,
    className: "st5",
    width: 45,
    height: 9
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 162,
    className: "st5",
    width: 36,
    height: 9
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 171,
    className: "st5",
    width: 27,
    height: 63
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 225,
    className: "st5",
    width: 9,
    height: 9
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 234,
    className: "st5",
    width: 27,
    height: 18
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 144,
    className: "st5",
    width: 9,
    height: 9
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 153,
    className: "st5",
    width: 45,
    height: 9
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 162,
    className: "st5",
    width: 27,
    height: 18
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 171,
    className: "st5",
    width: 9,
    height: 9
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 180,
    className: "st5",
    width: 27,
    height: 54
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 225,
    className: "st5",
    width: 9,
    height: 9
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 234,
    className: "st5",
    width: 36,
    height: 18
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 243,
    className: "st5",
    width: 18,
    height: 36
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 252,
    className: "st5",
    width: 27,
    height: 9
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 261,
    className: "st5",
    width: 18,
    height: 9
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 243,
    className: "st5",
    width: 9,
    height: 36
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 243,
    className: "st5",
    width: 18,
    height: 36
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 243,
    className: "st5",
    width: 9,
    height: 27
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 252,
    className: "st5",
    width: 18,
    height: 9
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 261,
    className: "st5",
    width: 9,
    height: 9
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 306,
    className: "st5",
    width: 27,
    height: 27
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 306,
    className: "st5",
    width: 45,
    height: 27
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 315,
    className: "st5",
    width: 9,
    height: 54
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 333,
    className: "st5",
    width: 9,
    height: 27
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 333,
    className: "st5",
    width: 9,
    height: 45
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 333,
    className: "st5",
    width: 9,
    height: 27
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 316,
    className: "st5",
    width: 9,
    height: 53
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 333,
    className: "st5",
    width: 9,
    height: 45
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 360,
    className: "st5",
    width: 27,
    height: 27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoloNftBlue);
export default __webpack_public_path__ + "static/media/yolo_nft-blue.d49411021b025b2d609f25b335d0c742.svg";
export { ForwardRef as ReactComponent };